import { render, staticRenderFns } from "./StaffManagementGrid.vue?vue&type=template&id=26985dc2"
import script from "./StaffManagementGrid.vue?vue&type=script&lang=js"
export * from "./StaffManagementGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports